import Swiper from 'swiper/bundle';
/*
    Swiper JS functions:
    1. slidesPerView: Number of slides visible at a time.
    2. spaceBetween: Gap between each slide.
    3. loop: Enables infinite scrolling of slides.
    4. breakpoints: Define different settings for various viewport widths.
    5. navigation: Enable previous and next buttons.
    6. pagination: Adds a pagination element (dots) for navigation.
    7. autoplay: Automatically transition slides after a delay.
    8. effect: Apply different slide effects such as fade, cube, flip, etc.
    9. grabCursor: Changes the cursor to a "grab" icon on hover.
    10. keyboard: Enable keyboard navigation for slides.
    11. mousewheel: Enable mouse wheel interaction for scrolling.
    12. scrollbar: Add a draggable scrollbar for navigation.
    13. on: Define event listeners like `init`, `slideChange`, `reachEnd`, etc.

    new Swiper('.swiper', {
        pagination: {
            el: '.swiper-pagination', // Class for pagination
            clickable: true, // Pagination dots are clickable
        },
        autoplay: {
            delay: 5000, // Auto-slide every 5 seconds
            disableOnInteraction: false, // Continue autoplay after interaction
        },
        effect: 'fade', // Slide transition effect (e.g., 'slide', 'fade', 'cube', 'coverflow', 'flip')
        grabCursor: true, // Show grab cursor on hover
        keyboard: {
            enabled: true, // Allow keyboard navigation
            onlyInViewport: true, // Only enable in the viewport
        },
        mousewheel: {
            invert: false, // Invert mousewheel scroll direction
        },
        scrollbar: {
            el: '.swiper-scrollbar', // Class for scrollbar
            draggable: true, // Allow dragging the scrollbar
        },
        on: {
            // Events example
            init: function () {
                console.log('Swiper initialized');
            },
            slideChange: function () {
                console.log('Slide changed to index:', this.activeIndex);
            },
            reachEnd: function () {
                console.log('Reached the end of slides');
            },
            autoplayStart: function () {
                console.log('Autoplay started');
            },
            autoplayStop: function () {
                console.log('Autoplay stopped');
            },
        }
    }
*/

var $ = jQuery;
$(document).ready(function ($) {
});

$(window).on('resize', function() {
});

$(window).on('click', function() {
});

$(window).on('scroll', function() {
});
